import React from 'react'

type Props = {
	name: string
	checked: boolean
	onChange: (checked: boolean) => unknown
}

export function CheckableFilter({ name, checked, onChange }: Props) {
	return (
		<label className="checkable-filter">
			<input
				type="checkbox"
				checked={checked}
				onChange={e => onChange(e.target.checked)}
			/>
			{ name }
		</label>
	)
}
